<template>
    <el-dialog title="Modifier prefixe / fournisseur" v-loading="loader" :visible.sync="display" width="50%">
        <span>Changer le prefix ou fournisseur pour les {{ items_selected }} produits selectionnés</span>
        <el-form class="row formPrefix" ref="form" :model="form">
            <div class="col-md-6">
                <el-form-item prop="mf_prefixe" label="Prefixe">
                    <el-select clearable v-model="form.mf_prefixe" placeholder="Prefixe" filterable allow-create>
                        <el-option v-for="item in prefixesOptions" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="col-md-6">
                <el-form-item prop="manufacturer_id" label="Fournisseurs">
                    <el-select clearable v-model="form.manufacturer_id" placeholder="Fournisseurs" filterable>
                        <el-option v-for="item in manufacturersOptions" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="col-md-12">
                <el-form-item prop="syncro" label="Synchroniser">
                    <el-switch v-model="form.syncro" active-text="Oui" inactive-text="Non"></el-switch>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                mf_prefixe: null,
                manufacturer_id: null,
                syncro: false
            },
            manufacturersOptions: [],
            prefixesOptions: [],
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    mounted() {
        axios.get('/manufacturers').then(r => {
            this.manufacturersOptions = r.data.data;
        });
        axios.get('/manufacturers/prefixes').then(r => {
            this.prefixesOptions = r.data.data;
        });
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                mf_prefixe: this.form.mf_prefixe,
                manufacturer_id: this.form.manufacturer_id,
                syncro: this.form.syncro,
                mode: 'change_prefix'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
